/**
 * Utility function to format price with currency symbol
 * @param {number|string} price - The price to format
 * @param {string} currency - The currency symbol (default: '£')
 * @returns {string} Formatted price string
 */
export const getNumericPrice = (price) => {
  if (price === "Free" || price === "Free" || !price) return 0;
  if (typeof price === "string") {
    // Remove currency symbols and extract number
    const cleaned = price.replace(/[£$€,+\s]/g, "");
    return parseFloat(cleaned) || 0;
  }
  return parseFloat(price) || 0;
};

export const formatPrice = (price, currency = '£') => {
  if (price === "Free" || price === "Free") {
    return "Free";
  }

  const numPrice = getNumericPrice(price);
  if (numPrice === 0) {
    return "Free";
  }
  return `${currency}${numPrice.toFixed(2)}`;
};

/**
 * Format price with space between currency and amount
 * @param {number|string} price - The price to format
 * @param {string} currency - The currency symbol (default: '£')
 * @returns {string} Formatted price string with space
 */
export const formatPriceWithSpace = (price, currency = '£') => {
  if (price === "Free" || price === "Free") {
    return "Free";
  }

  const numPrice = getNumericPrice(price);
  if (numPrice === 0) {
    return "Free";
  }
  return `${currency} ${numPrice.toFixed(2)}`;
};

/** Normalize API / settings VAT type to inclusive vs exclusive. */
export const parseVatInclusive = (vatTypeOrInclusive) => {
  if (vatTypeOrInclusive === true) return true;
  if (vatTypeOrInclusive === false) return false;
  const normalized = String(vatTypeOrInclusive ?? "")
    .trim()
    .toLowerCase();
  if (!normalized) return null;
  if (normalized === "inclusive" || normalized === "included") return true;
  if (normalized === "exclusive" || normalized === "excluded") return false;
  return null;
};

/** Customer-facing VAT/Tax line label — inclusive or exclusive, not included/excluded. */
export const formatVatLabel = (vatInclusive, label = "VAT") => {
  if (vatInclusive === true) return `${label} (inclusive)`;
  if (vatInclusive === false) return `${label} (exclusive)`;
  return label;
};
